<template>
  <v-btn
    rounded
    color="success"
    min-width="180"
    min-height="35"
    @click="finalizarAtestado"
    :block="$mq == 'sm'"
    :loading="finalizando"
    >Finalizar / Enviar</v-btn
  >
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import { getBase64 } from "@/global";
export default {
  computed: {
    ...mapState("atestado", ["dados", "atestadoEnviar", "atestSelec"]),
    ...mapState("anexos", ["docs"]),
  },
  data: () => ({
    finalizando: false,
    tipoDocto: "",
  }),
  methods: {
    ...mapGetters("atestado", ["getTiposDocsAnexar", "getTipoDados"]),
    async finalizarAtestado() {
      if (
        this.getTiposDocsAnexar().filter((doc) => doc.obrigatorio).length !=
        this.docs.filter((anexo) => anexo.obrigatorio).length
      ) {
        this.$toasted.error("Os documentos obrigatórios devem ser anexados");
        return;
      }

      this.finalizando = true;
      var data = {
        codconfigatest: this.atestadoEnviar.tipo,
        codconfigsituacao: this.atestadoEnviar.motivo,
        cid: this.atestadoEnviar.cid,
        codmedico: parseInt(this.atestadoEnviar.codMedico),
        medico: this.atestadoEnviar.nomeMedico,
        crmcro: this.atestadoEnviar.crmcro,
        justificativa: this.atestadoEnviar.justificativa,
        datainicio: this.atestadoEnviar.datainicial,
        datafim: this.atestadoEnviar.datafinal,
        coddependente: this.atestadoEnviar.dependente,
        ddd: this.atestadoEnviar.ddd,
        telefone: this.atestadoEnviar.telefone,
        ambiente: "WEB",
      };

      data.filenames = [];
      for (const doc of this.docs) {
        data.filenames.push({
          id: doc.codigo,
          doc: await getBase64(doc.file[0]),
        });
      }

      var acao = this.atestSelec
        ? `ALTERARATESTADO&codigo=${this.atestSelec.codigo}`
        : "INCLUIRATESTADO";

      await axios
        .post(`/colaborador/atestados?funcao=${acao}`, data)
        .then(async (res) => {
          if (res.data.success) {
            if (this.dados == "OUTROS DOCUMENTOS") {
              if (this.atestSelec) {
                this.$toasted.success("Documento alterado com sucesso");
              } else {
                this.$toasted.success("Documento enviado com sucesso");
              }
              this.$router.push({ path: "/documentos" });
            } else {
              if (this.atestSelec)
                this.$toasted.success("Atestado alterado com sucesso");
              else this.$toasted.success("Atestado enviado com sucesso");

              this.$router.push({ path: "/atestados" });
            }
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));

      this.finalizando = false;
    },
  },
};
</script>

<style></style>
